import React, { useState } from 'react';
import { Icon, Avatar, Badge, EmptyState } from '../components/UI';
import { useApp } from '../context/AppContext';

function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' }) + ' · ' + d.toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' });
}

export default function InboxPage() {
  const { user, data, markEmailRead } = useApp();
  const [selected, setSelected] = useState(null);

  const myEmails = data.emails
    .filter(e => e.to.includes(user.id))
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  const openEmail = async (email) => {
    setSelected(email);
    if (!email.read[user.id]) {
      await markEmailRead(email.id);
    }
  };

  const unreadCount = myEmails.filter(e => !e.read[user.id]).length;

  return (
    <div className="page-enter" style={{ maxWidth: 1280, margin: '0 auto', padding: '44px 28px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 32 }}>
        <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 30, fontWeight: 800, color: 'var(--dark)', margin: 0, letterSpacing: '-0.02em' }}>Inbox</h1>
        {unreadCount > 0 && <Badge bg="var(--orange-soft)" color="var(--orange)" dot>{unreadCount} unread</Badge>}
      </div>

      {myEmails.length === 0 ? (
        <EmptyState icon="inbox" title="Your inbox is empty" message="Messages from your coordinators will appear here." />
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: selected ? '340px 1fr' : '1fr', gap: 20, alignItems: 'start' }}>
          {/* Email list */}
          <div style={{ background: 'var(--white)', border: '1.5px solid var(--dark-10)', borderRadius: 'var(--radius-xl)', overflow: 'hidden' }}>
            {myEmails.map((email, i) => {
              const isRead = email.read[user.id];
              const isSelected = selected?.id === email.id;
              return (
                <div
                  key={email.id}
                  onClick={() => openEmail(email)}
                  style={{ padding: '16px 20px', borderBottom: i < myEmails.length - 1 ? '1px solid var(--dark-10)' : 'none', cursor: 'pointer', background: isSelected ? 'var(--orange-soft)' : isRead ? 'var(--white)' : 'rgba(236,125,42,0.04)', transition: 'background 0.15s', borderLeft: isSelected ? '3px solid var(--orange)' : '3px solid transparent' }}
                >
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                    <Avatar name={email.fromName} size={36} bg="var(--dark)" />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 3 }}>
                        <span style={{ fontFamily: 'var(--font-heading)', fontSize: 13, fontWeight: isRead ? 600 : 700, color: 'var(--dark)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{email.fromName}</span>
                        {!isRead && <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--orange)', flexShrink: 0 }} />}
                      </div>
                      <p style={{ fontSize: 13, fontWeight: isRead ? 400 : 600, color: isRead ? 'var(--dark-60)' : 'var(--dark)', margin: '0 0 2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{email.subject}</p>
                      <p style={{ fontSize: 11, color: 'var(--dark-40)', margin: 0 }}>{formatDate(email.date)}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Email detail */}
          {selected && (
            <div style={{ background: 'var(--white)', border: '1.5px solid var(--dark-10)', borderRadius: 'var(--radius-xl)', padding: 32 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24 }}>
                <div>
                  <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: 22, fontWeight: 700, color: 'var(--dark)', margin: '0 0 8px', letterSpacing: '-0.01em' }}>{selected.subject}</h2>
                  <p style={{ fontSize: 13, color: 'var(--dark-60)', margin: 0 }}>{formatDate(selected.date)}</p>
                </div>
                <button onClick={() => setSelected(null)} style={{ background: 'var(--dark-05)', border: 'none', width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--dark-60)', flexShrink: 0 }}>
                  <Icon name="x" size={15} />
                </button>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px', background: 'var(--dark-05)', borderRadius: 'var(--radius-md)', marginBottom: 24 }}>
                <Avatar name={selected.fromName} size={38} bg="var(--dark)" />
                <div>
                  <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--dark)', margin: '0 0 1px', fontFamily: 'var(--font-heading)' }}>{selected.fromName}</p>
                  <p style={{ fontSize: 12, color: 'var(--dark-60)', margin: 0 }}>{selected.fromEmail}</p>
                </div>
                <div style={{ marginLeft: 'auto' }}>
                  <Badge bg="var(--dark-10)" color="var(--dark-60)">Coordinator</Badge>
                </div>
              </div>

              <div style={{ fontSize: 15, color: 'var(--dark)', lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>{selected.body}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
